var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8457 8V5C3.8457 3.67392 4.37249 2.40215 5.31017 1.46447C6.24785 0.526784 7.51962 0 8.8457 0C10.1718 0 11.4436 0.526784 12.3812 1.46447C13.3189 2.40215 13.8457 3.67392 13.8457 5V8H14.8457C15.3761 8 15.8848 8.21071 16.2599 8.58579C16.635 8.96086 16.8457 9.46957 16.8457 10V18C16.8457 18.5304 16.635 19.0391 16.2599 19.4142C15.8848 19.7893 15.3761 20 14.8457 20H2.8457C2.31527 20 1.80656 19.7893 1.43149 19.4142C1.05642 19.0391 0.845703 18.5304 0.845703 18V10C0.845703 9.46957 1.05642 8.96086 1.43149 8.58579C1.80656 8.21071 2.31527 8 2.8457 8H3.8457ZM2.8457 10V18H14.8457V10H2.8457ZM5.8457 8H11.8457V5C11.8457 4.20435 11.5296 3.44129 10.967 2.87868C10.4044 2.31607 9.64135 2 8.8457 2C8.05005 2 7.28699 2.31607 6.72438 2.87868C6.16177 3.44129 5.8457 4.20435 5.8457 5V8Z",
    fill: "#B54708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9b47e5cf461ab0bd9ab4f0d2b8f2d112.svg";
export { ForwardRef as ReactComponent };